(() => {
  const moneyPattern = /(?:-?\s*(?:₪|NIS|ILS)\s*[\d,.\s\u200e\u200f]+|-?\s*[\d,.\s\u200e\u200f]+\s*(?:₪|NIS|ILS))(?:\s*ILS)?/gi;
  const excludedSelector = 'script, style, template, textarea, .macrame-money';

  function createMoneyElement(value) {
    const negative = /-/.test(value);
    const amount = (value.match(/[\d][\d,.\s\u200e\u200f]*/) || [''])[0].trim();
    const money = document.createElement('bdi');

    money.className = 'macrame-money';
    money.dir = 'ltr';
    money.textContent = `${negative ? '-' : ''}₪ ${amount}`;
    return money;
  }

  function normalizeTextNode(node) {
    const parent = node.parentElement;
    const value = node.nodeValue;

    moneyPattern.lastIndex = 0;
    if (!parent || parent.closest(excludedSelector) || !value || !moneyPattern.test(value)) return;

    moneyPattern.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let cursor = 0;

    value.replace(moneyPattern, (match, offset) => {
      fragment.append(value.slice(cursor, offset), createMoneyElement(match));
      cursor = offset + match.length;
      return match;
    });
    fragment.append(value.slice(cursor));
    node.replaceWith(fragment);
  }

  function normalizePrices(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;

    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(normalizeTextNode);
  }

  function start() {
    normalizePrices(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) normalizeTextNode(node);
          if (node.nodeType === Node.ELEMENT_NODE) normalizePrices(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
